import { ColumnAccessorSortable } from '@/types/columns';

const MASKABLE_COLUMNS_ARRAY = [
  ColumnAccessorSortable.isBestSeller,
  ColumnAccessorSortable.gtin,
  ColumnAccessorSortable.sku,
  ColumnAccessorSortable.shopifyVariantId,
  ColumnAccessorSortable.discountedPrice,
  ColumnAccessorSortable.marginPercentage,
  ColumnAccessorSortable.couponExpirationDate,
  ColumnAccessorSortable.couponHowToUse,
  ColumnAccessorSortable.couponTerms,
  ColumnAccessorSortable.potentialSalesVolume,
  ColumnAccessorSortable.madeIn,
  ColumnAccessorSortable.productType,
  ColumnAccessorSortable.eeePrice,
] as const satisfies readonly ColumnAccessorSortable[];

const MASKABLE_COLUMNS = new Set<ColumnAccessorSortable>(
  MASKABLE_COLUMNS_ARRAY
);

export function isMaskableColumn(
  columnAccessor: ColumnAccessorSortable
): boolean {
  return MASKABLE_COLUMNS.has(columnAccessor);
}
